export default __webpack_public_path__ + "static/media/upButton.41b575dc.svg";